import ButtonLink from "PFComponents/button/button_link";
import { Icon } from "PFComponents/icon";
import { useTranslation } from "react-i18next";

import css from "./shortlist_detail_action.module.scss";

type ShortlistDetailActionProps = {
  id: number | undefined;
};

export const ShortlistDetailAction = ({ id }: ShortlistDetailActionProps) => {
  const { t } = useTranslation("bookingModule");
  return (
    <>
      {id && (
        <ButtonLink href={`/activities/${id}/shortlist`} kind="secondary" rootClassName={css.shortlistButton}>
          <Icon name="workflow" size="md" />
          {t("details.viewInRoleShortlist")}
        </ButtonLink>
      )}
    </>
  );
};
